import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import hr from './locales/hr.json'
import en from './locales/en.json'
import de from './locales/de.json'
import it from './locales/it.json'

// Croatian is the primary market; en/de/it are offered for tourists and expats.
export const SUPPORTED_LANGUAGES = ['hr', 'en', 'de', 'it']
const STORAGE_KEY = 'lang'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      hr: { translation: hr },
      en: { translation: en },
      de: { translation: de },
      it: { translation: it },
    },
    supportedLngs: SUPPORTED_LANGUAGES,
    fallbackLng: 'hr',
    // 'en-US' → 'en', 'de-DE' → 'de', 'hr-HR' → 'hr'
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false }, // React already escapes
    detection: {
      // Manual choice (localStorage) wins, then the browser locale, then fallback.
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: STORAGE_KEY,
      caches: ['localStorage'],
    },
    react: { useSuspense: false },
  })

// Keep <html lang> in sync with the active language.
const applyLang = (lng) => {
  const base = (lng || 'hr').split('-')[0]
  document.documentElement.lang = SUPPORTED_LANGUAGES.includes(base) ? base : 'hr'
}
applyLang(i18n.resolvedLanguage || i18n.language)
i18n.on('languageChanged', applyLang)

export default i18n
